module.exports = __webpack_public_path__ + "6ef2e387357b938a36688d391f76cf6f.svg";